import { arrayAndMap as r } from "./utils.js";
function p(e) {
  const t = {
    "en-GB": import("./rooms-CpQK0jNE.js"),
    "de-DE": import("./rooms-DTPXtvLv.js")
  };
  return (t[e] || t["en-GB"]).then(
    (o) => r(
      o.default
    )
  );
}
function i(e) {
  const t = {
    "en-GB": import("./equip-groups-ClP-LPuA.js"),
    "de-DE": import("./equip-groups-DwGGyLGZ.js")
  };
  return (t[e] || t["en-GB"]).then(
    (o) => o.default
  );
}
export {
  i as getEquipGroups,
  p as getRooms
};
//# sourceMappingURL=data.js.map
